module.exports = __webpack_public_path__ + "img/htkj_10.c20f4e6f.jpg";